import "../../CommonImports";
import "../../Core/core.css";
import "./Panel.css";
import * as React from "react";
import { ScreenContext, ScreenSize } from '../../Core/Util/Screen';
import { Callout, ContentJustification, ContentLocation, ContentOrientation, ContentSize } from '../../Callout';
import { FocusZoneKeyStroke } from '../../FocusZone';
import { Observer } from '../../Observer';
import { Spacing, Surface, SurfaceContext } from '../../Surface';
import { css, KeyCode } from '../../Util';
export class CustomPanel extends React.Component {
    constructor(props) {
        super(props);
        this.calloutContentRef = React.createRef();
        this.defaultActiveElement = () => {
            // We don't ever want the Panel to set focus to the body, so if the defaultActiveElement
            // prop that is provided cannot be found, instead use the panel's default focus element.
            const { defaultActiveElement } = this.props;
            const selector = typeof defaultActiveElement === "function" ? defaultActiveElement() : defaultActiveElement;
            if (selector && this.calloutContentRef.current) {
                const matches = this.calloutContentRef.current.querySelectorAll(selector);
                if (matches && matches.length) {
                    return selector;
                }
            }
            return ".bolt-panel-focus-element";
        };
        // TODO: Change to false in M150
        this.state = {
            isDisplayed: true
        };
    }
    render() {
        const { ariaLabel, ariaLabelledBy, blurDismiss, calloutClassName, children, className, contentClassName, escDismiss, id, lightDismiss, modal, onDismiss, portalProps, size = ContentSize.Medium } = this.props;
        const { isDisplayed } = this.state;
        return (React.createElement(Observer, { size: this.context.size }, (props) => {
            const fullscreen = props.size === ScreenSize.xsmall;
            return (React.createElement(Callout, { ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, blurDismiss: blurDismiss, className: css("bolt-panel", calloutClassName, isDisplayed === false && "no-events"), contentClassName: css(contentClassName, "bolt-panel-callout-content scroll-auto", isDisplayed ? "in" : "out", fullscreen ? "bolt-panel-fullscreen absolute-fill" : "relative"), contentJustification: ContentJustification.Stretch, contentLocation: ContentLocation.End, contentOrientation: ContentOrientation.Column, contentRef: this.calloutContentRef, contentShadow: true, contentSize: fullscreen ? undefined : size, escDismiss: escDismiss, id: id, focuszoneProps: {
                    circularNavigation: true,
                    defaultActiveElement: this.defaultActiveElement,
                    focusOnMount: true,
                    handleTabKey: true,
                    includeDefaults: true,
                    postprocessKeyStroke: function (event) {
                        // We want to prevent moving outside the panel if there are no focusable elements in the panel.
                        event.which === KeyCode.tab && event.preventDefault();
                        return FocusZoneKeyStroke.IgnoreParents;
                    }
                }, lightDismiss: lightDismiss && isDisplayed !== false, modal: modal && isDisplayed !== false, onDismiss: onDismiss, portalProps: portalProps },
                React.createElement(SurfaceContext.Consumer, null, surfaceContext => (React.createElement(Surface, Object.assign({}, surfaceContext, { spacing: Spacing.default }),
                    React.createElement("div", { className: css(className, "bolt-panel-root flex-column flex-grow scroll-auto") },
                        React.createElement("div", { className: "bolt-panel-focus-element no-outline", tabIndex: -1 }),
                        children))))));
        }));
    }
    // TODO: Uncomment in M150
    /* public componentDidMount() {
        setTimeout(() => {
            this.setState({ isDisplayed: true });
        }, 0);
    }

    public componentWillUnmount() {
        if(false) {
            if(this.state.isDisplayed === true) {
                console.error("Panel was unmounted while still displayed; call animateOut first and unmount after the returned promise resolves");
            }
        }
    } */
    animateOut() {
        return Promise.resolve();
        // TODO: Uncomment in M150
        /* return new Promise(resolve => {
            this.setState({ isDisplayed: false });

            setTimeout(() => {
                resolve();
            }, 200);
        }); */
    }
}
CustomPanel.defaultProps = {
    escDismiss: true,
    lightDismiss: true,
    modal: true
};
CustomPanel.contextType = ScreenContext;
